import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
// import serviceWorker from './serviceWorker';

const redirectLegacyAgendaDomain = () => {
    const legacyHosts = [
        'agendadigital.mxthermomix.com',
        'www.agendadigital.mxthermomix.com'
    ];

    if (!legacyHosts.includes(window.location.hostname.toLowerCase())) {
        return;
    }

    const targetUrl = `https://www.mithermomix.mx${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.replace(targetUrl);
};

redirectLegacyAgendaDomain();

ReactDOM.render(
    //<React.StrictMode>
        <Router>
            <App />
        </Router>
    //</React.StrictMode>
  , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker();
